export const UPDATE_STAFF = 'UPDATE_STAFF';
export const SET_STAFF = 'SET_STAFF';
export const SET_STAFFS = 'SET_STAFFS';
export const LIST_STAFFS = 'LIST_STAFFS';
export const LOAD_STAFF = 'LOAD_STAFF';
export const SAVE_STAFF = 'SAVE_STAFF';
export const REMOVE_STAFF = 'REMOVE_STAFF';
